/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Table, Tag, Tooltip, message, Popconfirm, Select, Button } from 'antd';
import moment from 'moment';
import MarkReadIcon from '@iconscout/react-unicons/icons/uil-comment-alt-check';
import MarkUnReadIcon from '@iconscout/react-unicons/icons/uil-comment-alt-block';
import UilEye from '@iconscout/react-unicons/icons/uil-eye';


// import FormDialog from './FormDialog';
import { TableWrapper } from '../../../container/styled';
import { BtnWithIcon, Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { themeColor } from '../../../config/theme/themeVariables';
import { NOTIFICATION_READ_STATUS, NOTIFICATION_TYPES, NOTIFICATION_TYPES_ARRAY, SOCKET_ACTIONS } from '../../../config/config';
import websocketManager from '../../../config/websocketManager';
import NotificationDetailsDialog from '../notification-details-dialog';

const { Option } = Select

function DataTable() {
  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [notiTypeID, setNotiTypeID] = useState(-1);
  const [notiReadStatus, setNotiReadStatus] = useState(-1);
  const [currentPage, setCurrentPage] = useState(1);
  const [notiData, setNotiData] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(false);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/common/noti/query', {
        page: currentPage,
        pageSize,
        noti_type_id: notiTypeID,
        noti_read_type: notiReadStatus,
      });
      const { data, total } = response.data;
      setTableData(data);
      setTotalRows(total);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  useEffect(() => {
    fetchTableData();
    if (reload) setReload(false)
  }, [currentPage, pageSize, reload]);

  useEffect(() => {
    const handleAction = (data) => {
      try {
        switch (Number(data.event_id)) {
          case SOCKET_ACTIONS.FETCH_NOTIFICATIONS:
            fetchTableData();
            break;
          default:
            break;
        }
      } catch (error) {
        message.error(`Error handling socket message : ${error.message}`)
      }
    };
    // Register for an action_id
    websocketManager.registerObserver(SOCKET_ACTIONS.FETCH_NOTIFICATIONS, handleAction);

    return () => {
      // Unregister the observer on component unmount
      websocketManager.unregisterObserver(SOCKET_ACTIONS.FETCH_NOTIFICATIONS, handleAction);
    };
  }, []);

  const handleDeleteRowClck = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (dbRec) {
        setBusy(true)
        const response = await DataService.post('/common/noti/read-unread', {
          id: dataID,
          // read_status: dbRec.read_status === 0 ? 1 : 0
          read_status: 1
        });

        const { status } = response.data;
        if (status) {
          setReload(true)
          message.success(response.data.message)
        } else {
          message.error(response.data.message)
        }
        setBusy(false)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const handleMarkAllReadClick = async (event) => {
    try {
      setBusy(true)
      const response = await DataService.post('/common/noti/mark-all-read');
      const { status } = response.data;
      if (status) {
        setReload(true)
        message.success(response.data.message)
      } else {
        message.error(response.data.message)
      }
      setBusy(false)
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
      setBusy(false)
    }
  }

  const hanldeInfoRowClick = async (event) => {
    try {
      const { currentTarget } = event;
      const dataID = Number(currentTarget.getAttribute('data-index') || 0)
      const dbRec = tableData.find(item => item.id === dataID);
      if (Number(dbRec.read_status) === NOTIFICATION_READ_STATUS.UNREAD) {
        setBusy(true)
        const response = await DataService.post('/common/noti/read-unread', {
          id: dataID,
          // read_status: dbRec.read_status === 0 ? 1 : 0
          read_status: 1
        });

        const { status } = response.data;
        if (status) {
          setReload(true)
          setNotiData(dbRec)
          setShowDetails(true)
        } else {
          message.error(response.data.message)
        }
        setBusy(false)
      } else {
        setNotiData(dbRec)
        setShowDetails(true)
      }
    } catch (error) {
      message.error(`Error sending request:  ${error.message}`)
    }
  }

  const TableColumns = [
    {
      title: 'ID#',
      dataIndex: 'id',
      key: 'id',
      field: 'id',
      export: false,

      // onCell: () => ({ style: { width: '20px !important', backgroudColor: 'red' } }),
    },
    {
      title: 'Type',
      dataIndex: 'type_id',
      key: 'type_id',
      field: 'type_id',
      export: false,
      // onCell: () => ({ className: 'text-center w-1/4' }),

      render: (type_id) => <p>{NOTIFICATION_TYPES[type_id]}</p>
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      field: 'description',
      export: true,
      onCell: () => ({ className: 'text-wrap max-w-lg' }),
    },
    {
      title: 'Ago',
      dataIndex: 'created_at',
      key: 'created_at',
      field: 'created_at',
      export: true,
      onCell: () => ({ className: 'w-20 text-wrap' }),
      render: (created_at) => moment(created_at).fromNow()
    },
    {
      title: 'Status',
      dataIndex: 'read_status',
      key: 'read_status',
      field: 'read_status',
      export: true,
      width: 10,
      // onCell: () => ({
      //   style: { width: 5 },
      // }),
      // onCell: () => ({ className: 'w-10 text-center' }),
      // onHeader: () => { },

      render: (read_status) => {
        let color = themeColor['danger-color']
        let lblStr = '';

        if (Number(read_status) === 0) {
          lblStr = 'Unread'
          color = themeColor['warning-color']
        } else if (Number(read_status) === 1) {
          lblStr = 'Read'
          color = themeColor['success-color']
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        )
      },
    },
    {
      title: 'Actions',
      export: false,
      onCell: () => ({ className: 'w-10' }),
      render: (rowData) => {
        // console.log('rowData', rowData)
        return (<div className='flex justify-center select-none'>

          {/* {rowData.read_status === 0 && <Tooltip title={`Mark notification as ${rowData.read_status === 0 ? 'read' : 'unread'}`} className='select-none'>
            <Popconfirm
              title={`Are you sure to ${rowData.read_status === 0 ? 'read' : 'unread'} this notification ?`}
              onConfirm={handleDeleteRowClck}
              okButtonProps={{
                disabled: busy,
                'data-index': rowData.id

              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <BtnWithIcon className='ninjadash-delete'>
                {rowData.read_status === 0 ?
                  <MarkReadIcon
                    className='ninjadash-delete hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                  :
                  <MarkUnReadIcon
                    className='ninjadash-delete hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                    size={20}
                  />
                }
              </BtnWithIcon>
            </Popconfirm>
          </Tooltip>
          } */}

          <Tooltip title='Show Details' className='select-none'>
            <BtnWithIcon
              onClick={hanldeInfoRowClick}
              data-index={rowData.id}
              disabled={busy}
            >
              <UilEye
                className='hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out'
                size={20}
              />
            </BtnWithIcon>
          </Tooltip>
        </div >
        )
      },
    },
  ];

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Notifications Center" routes={[]} />
      <Main>
        <div className="p-4">
          <div className="flex justify-end items-center mb-4">
            <div className="flex flex-col align-center justify-center">
              <div className='w-full'>Notification Status</div>
              <Select value={notiReadStatus} onChange={({ value }) => { setNotiReadStatus(value); setReload(true) }} className='h-10 w-40' loading={busy} labelInValue='ASAD'>
                {
                  [{ id: -1, label: 'Show All' }, { id: 0, label: 'All UnRead' }, { id: 1, label: 'All Read' }]
                    .map(item => <Option value={item.id}>{item.label}</Option>)
                }
              </Select>
            </div>
            &nbsp;
            <div className="flex flex-col align-center justify-center">
              <div >Notification Type</div>
              <Select value={notiTypeID} onChange={({ value }) => { setNotiTypeID(value); setReload(true) }} className='h-10 w-80' loading={busy} labelInValue='ASAD'>
                {
                  [{ id: -1, title: 'Show All' }, ...NOTIFICATION_TYPES_ARRAY]
                    .map(item => <Option value={item.id}>{item.title}</Option>)
                }
              </Select>
            </div>
            <Button
              className='mt-4 ml-2'
              type="primary"
              disabled={busy}
              onClick={handleMarkAllReadClick}>
              Mark All Read
            </Button>
          </div>
          <div className="ninjadasj-datatable">
            <TableWrapper >
              <Table
                rowKey={(record) => `${record.id}`} // Generate a unique key for each row
                key={`${currentPage}-${pageSize}`} // Add a unique key to force re-render
                loading={busy}
                bordered
                virutal
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={tableData}
                columns={TableColumns}
                scroll={{ x: 'max-content' }} // Ensure table has a fixed scroll behavior
              />
            </TableWrapper>
            {showDetails && <NotificationDetailsDialog showDialog={setShowDetails} setReload={setReload} notiData={notiData} />}
          </div>
        </div>
      </Main>
    </>
  );
}

export default DataTable;
